export default __webpack_public_path__ + "static/media/STATIC.180ec003.png";